import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    claimsBasedCachingEnabled: true,
  },
};

export const loginRequest = {
  scopes: [`${process.env.REACT_APP_AZURE_CLIENT_ID}/.default`],
  extraQueryParameters: { prompt: 'select_account' },
};

export enum Languages {
  EN = 'en',
  FR = 'fr',
  FRCA = 'fr-ca',
}

export const DEFAULT_LANGUAGE = Languages.EN;

export type EnrollConfiguration = {
  API_ROOT: string;
  HOST_URL: string;
  PROTOCOL: string;
  SMART_HUB_DOMAIN: string;
  DEFAULT_SUBDOMAIN: string;
};

export const config: EnrollConfiguration = {
  API_ROOT: String(process.env.REACT_APP_API_ROOT),
  HOST_URL: String(process.env.REACT_APP_HOST_URL),
  PROTOCOL: String(process.env.REACT_APP_PROTOCOL),
  SMART_HUB_DOMAIN: String(process.env.REACT_APP_SMART_HUB_DOMAIN),
  DEFAULT_SUBDOMAIN: String(process.env.REACT_APP_DEFAULT_SUBDOMAIN),
};
